import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@awtoban/ui";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  typedTotalTn: string;
  perAxleSumTn: string;
  onUsePerAxle: () => void;
  onEdit: () => void;
}

/** Tonnes → integer centitonnes, so the diff never drifts on float subtraction. */
function toCentitonnes(tn: string): number {
  return Math.round(Number(tn) * 100);
}

export function ReconcileDialog({ open, typedTotalTn, perAxleSumTn, onUsePerAxle, onEdit }: Props) {
  const { t } = useTranslation();
  const diffCt = toCentitonnes(perAxleSumTn) - toCentitonnes(typedTotalTn);
  const diff = (diffCt / 100).toFixed(2);
  return (
    <Dialog open={open}>
      <DialogContent blocking>
        <DialogHeader>
          <DialogTitle>{t("reconcile.title")}</DialogTitle>
          <DialogDescription>{t("reconcile.explanation")}</DialogDescription>
        </DialogHeader>

        <div className="text-sm">
          <dl className="tabular grid grid-cols-[max-content_1fr] gap-x-6 gap-y-1">
            <dt className="text-ink-muted">{t("reconcile.typed_total")}</dt>
            <dd>{typedTotalTn} t</dd>
            <dt className="text-ink-muted">{t("reconcile.per_axle_sum")}</dt>
            <dd>{perAxleSumTn} t</dd>
            <dt className="text-ink-muted">{t("reconcile.difference")}</dt>
            <dd className="font-medium text-ink">
              {diffCt >= 0 ? "+" : ""}
              {diff} t
            </dd>
          </dl>
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <Button variant="secondary" onClick={onEdit} autoFocus>
            {t("reconcile.edit_values")}
          </Button>
          <Button onClick={onUsePerAxle}>
            {t("reconcile.use_per_axle", { sum: perAxleSumTn })}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
